import React, { ComponentProps } from "react";
import { Select } from "../../../components/input-functions";
import { AdvanceSalaryStatus } from "../../../dto";

interface AdvanceSalaryStatusFilterProps {
  status: AdvanceSalaryStatus;
  options: ComponentProps<typeof Select>["options"];
  onChange: ComponentProps<typeof Select>["onChange"];
}

export default function AdvanceSalaryStatusFilter({
  status,
  options,
  onChange,
}: AdvanceSalaryStatusFilterProps) {
  return (
    <div style={{ width: "40%" }}>
      <h6 style={{ color: "var(--clr-text-secondary)" }}>Status Filter</h6>
      <Select
        value={status}
        fieldName="ADVANCE_SALARY_STATUS"
        options={options}
        onChange={onChange}
      />
    </div>
  );
}
